import { Ga4EventService } from './ga4Event.service';
import type {
  IGaEcommerce,
  IGaEcommerceItemList,
} from './gaEcommerce.interface';

export class Ga4EventEcommerceService extends Ga4EventService {
  private clearEcommerce(): void {
    if (window.dataLayer) {
      window.dataLayer.push({ ecommerce: null });
    }
  }

  public addToCart(
    data: IGaEcommerce,
    meta?: { widget?: string; position?: number },
  ): void {
    this.clearEcommerce();
    super.fireEvent('con_add_to_cart', {
      ecommerce: data,
      widget: meta?.widget,
      ...(meta?.position != null && { position: meta.position }),
    });
  }

  public viewCart(data: IGaEcommerce): void {
    this.clearEcommerce();
    super.fireEvent('view_cart', {
      ecommerce: data,
    });
  }

  public viewItemList(data: IGaEcommerceItemList): void {
    this.clearEcommerce();
    super.fireEvent('con_view_item_list', {
      ecommerce: data,
    });
  }

  public viewItem(
    data: IGaEcommerce,
    meta?: {
      isFromBundleBannerSku?: string;
      isFromBundlePageSku?: string;
    },
  ): void {
    this.clearEcommerce();
    super.fireEvent('con_view_item', {
      ecommerce: data,
      is_from_bundle_banner_sku: meta?.isFromBundleBannerSku,
      is_from_bundle_page_sku: meta?.isFromBundlePageSku,
    });
  }
}

export const ga4EventEcommerceService = new Ga4EventEcommerceService();
